import InputComment from "../InputComment";
import CommentListView from "../CommentListView";

import { DiscussionGroupType } from "../../constants/enums";
import { useComment, useSignalr } from "../../hooks/comment";
import { AlertProvider } from "../../providers/AlertProvider";
import { useCommentContext } from "../../providers/CommentProvider";

import "../../styles/comment.css";
import "../../styles/inputComment.css";
import "../../styles/commentListView.css";
import "../../styles/commentContainer.css";
import Helpers from "../../commons/helpers";


enum CommentMethod {
    None,
    Readtime,
}

interface IProps {
    requestLevel: number;
    discussionGroupType: DiscussionGroupType;

    threadId: string;
    channelId: string;
    commentMethod: CommentMethod,

    isDisableDelete?: boolean;
    isDisableUpdate?: boolean;
    isDisableReport?: boolean;
    isHidenTotalAssessment?: boolean;

    onCallBack?: () => void;
}

const CommentContainer = ({
    threadId,
    channelId,
    requestLevel,
    commentMethod,
    isDisableReport,
    isDisableUpdate,
    isDisableDelete,
    discussionGroupType,
    isHidenTotalAssessment,
    onCallBack,
    ...rest
}: IProps) => {

    const { userLogin } = useCommentContext();

    const {
        listCommentRef,
        listComments,
        pageData,
        getListComment,
        setPageData,
        setListComments,
        onViewReplyComment,
        handleReaction,
        handleUnReaction,
        handleHideComment,
        deleteComment,
        createComment,
        updateComment,
    } = useComment({
        threadId,
        requestLevel,
        discussionGroupType,
    });

    const { joinRoom, deleteMessage, sendMessage, updateMessage } = useSignalr({
        listCommentRef,
        discussionGroupType,
        setListComments,
        setPageData,
    });

    return (
        <AlertProvider>
            <div {...rest} className="cr-container cr-common">
                {
                    !isHidenTotalAssessment &&
                    <div className="cr-total-count">
                        <p>{`${pageData.totalCount} bài đánh giá`}</p>
                    </div>
                }
                {discussionGroupType !== DiscussionGroupType.Rating && (
                    <InputComment
                        visible={false}
                        isComment={true}
                        onCancelComment={() => { }}
                        dataReplyComment={{ userComment: userLogin }}
                        createGuest={(commentMethod === CommentMethod.Readtime) ? joinRoom : undefined}
                        sendMessage={(discussionValue: string, replyTo?: string) => {
                            (commentMethod === CommentMethod.Readtime)
                                ? sendMessage(discussionValue, replyTo)
                                : createComment({
                                    channelId: channelId,
                                    message: discussionValue,
                                    replyTo: replyTo,
                                })

                            Helpers.isFunction(onCallBack) && onCallBack();
                        }}
                    />
                )}
                <CommentListView
                    requestLevel={requestLevel}
                    dataComment={listComments || []}
                    isDisableDelete={isDisableDelete}
                    isDisableUpdate={isDisableUpdate}
                    isDisableReport={isDisableReport}

                    reaction={handleReaction}
                    unReaction={handleUnReaction}
                    onHideReplyComment={handleHideComment}
                    onViewReplyComment={onViewReplyComment}
                    readMoreComment={() => getListComment(true)}
                    isReadMore={pageData.currentPage < pageData.totalPages ? true : false}
                    createGuest={(commentMethod === CommentMethod.Readtime) ? joinRoom : undefined}

                    deleteMessage={(messageId: string) => {
                        (commentMethod === CommentMethod.Readtime)
                            ? deleteMessage(messageId)
                            : deleteComment(messageId)

                        Helpers.isFunction(onCallBack) && onCallBack();
                    }}

                    sendMessage={(discussionValue: string, replyTo?: string) => {
                        (commentMethod === CommentMethod.Readtime)
                            ? sendMessage(discussionValue, replyTo)
                            : createComment({
                                channelId: channelId,
                                message: discussionValue,
                                replyTo: replyTo,
                            })

                        Helpers.isFunction(onCallBack) && onCallBack();
                    }}

                    updateMessage={(messageId: string, message: string) => {
                        (commentMethod === CommentMethod.Readtime)
                            ? updateMessage(messageId, message)
                            : updateComment({
                                message: message,
                                messageId: messageId,
                            })

                        Helpers.isFunction(onCallBack) && onCallBack();
                    }}
                />
            </div>
        </AlertProvider>
    );
};
export default CommentContainer;
